import { StoreEntityType } from 'ngx-unificator/store';
import { HttpStatus } from '../services/response-handler.service';

export type SummerPageResponse = SummerPageType[] | { statusCode: HttpStatus };

export type SummerStateType = {
  page: SummerPageType;
  currentBonus: CurrentBonusItemType;
  currentPrize: CurrentPrizeType;
  isUserCanParticipateInPromo: boolean;
  isUserCanPartiallyParticipateInPromo: boolean;
  isUserAlreadyActivatedPromoLootbox: boolean;
  isAllWelcomePackClaimed: boolean;
  isLoadedPromo: boolean;
  isPromoInitialized: boolean;
  isShowWelcomeModalPromo: boolean;
  isSpinFinished: boolean;
  slots: SlotType;
}

export type SummerPageType = {
  Title: string;
  Description: string;
  Prize: string;
  PrizeDesc: string;
  UnlockTitle: string;
  HowItWorksTitle: string;
  HowItWorksSteps: { title: string }[];
  GamesTitle: string;
  GamesDesc: string;
  TournamentsTitle: string;
  TelegramTitle: string;
  TelegramLink: string;
  TryTomorrowTitle: string;
  TryTomorrowDesc: string;
  BonusShopTitle: string;
  BonusShopDesc: string;
  BonusShopLink: string;
  DailyMissionDoneTitle: string;
  DailyMissionDoneDesc: string;
  HowWorksTerms: string;
  GeneralTerms: string;
  DepositRuleTitle: string;
  DepositRuleDesc: string;
  SpinTitle: string;
  SpinDesc: string;
  WinTitle: string;
  WinDesc: string;
  GameCategory: number;
  unpublishAt: any;
  publishAt: any;
  Prizes: { fs: number, image: number }[];
}

export type CurrentBonusItemType = {
  fs?: any;
  cash?: any;
  welcomeLootbox?: any;
  promoIssuedLootbox?: any;
}

export type CurrentPrizeType = {
  fs_count?: number;
  cash?: any;
}

export type SlotType = {
  prizes?: SlotPrizeItemType[];
  initialPrizes?: SlotPrizeItemType[];
  sequencePrizes?: SlotPrizeItemType[];
  finalPrize?: SlotPrizeItemType;
};

export type SlotPrizeItemType = {
  fs: number;
  image: string;
}

export const summerStore: StoreEntityType<SummerStateType> = {
  page: null,
  currentBonus: null,
  currentPrize: null,
  isUserCanParticipateInPromo: false,
  isUserCanPartiallyParticipateInPromo: false,
  isUserAlreadyActivatedPromoLootbox: false,
  isAllWelcomePackClaimed: false,
  isLoadedPromo: false,
  isShowWelcomeModalPromo: false,
  isSpinFinished: false,
  isPromoInitialized: false,
  slots: {
    prizes: [],
    initialPrizes: [],
    sequencePrizes: [],
    finalPrize: null,
  },
};

export type SummerStoreEntity = typeof summerStore;
